export const version = '0.787.0'
export const chameleonWebVersion = '9.13.2'
export const chameleonCoreVersion = '7.9.2'
